import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Euro, Save, CreditCard } from "lucide-react";
import api, { apiErr } from "@/lib/api";

export default function SettingsPanel() {
  const [c, setC] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setC(r.data.commission_per_pizza)).catch(() => {}); }, []);

  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/settings", { commission_per_pizza: parseFloat(c) }); setC(data.commission_per_pizza); toast.success("Réglages enregistrés"); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="grid md:grid-cols-2 gap-6 max-w-3xl">
      <div className="card-cocarde p-6">
        <h3 className="font-display text-xl cc-navy flex items-center gap-2"><Euro size={18} className="text-cc-red" /> Commission par pizza</h3>
        <p className="text-slate-500 text-sm mt-1 mb-4">Montant prélevé par COCARDE Pizza sur chaque pizza vendue. Interne — jamais affiché au public.</p>
        <div className="relative w-40">
          <input data-testid="settings-commission" type="number" step="0.10" value={c} onChange={(e) => setC(e.target.value)}
            className="w-full border border-slate-300 rounded-xl px-4 py-3 pr-8 outline-none focus:border-cc-red font-bold cc-navy" />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">€</span>
        </div>
        <button data-testid="settings-save" onClick={save} disabled={busy} className="btn-cocarde mt-4 inline-flex items-center gap-2 disabled:opacity-60"><Save size={16} /> {busy ? "…" : "Enregistrer"}</button>
      </div>
      <div className="card-cocarde p-6">
        <h3 className="font-display text-xl cc-navy flex items-center gap-2"><CreditCard size={18} className="text-cc-blue" /> Paiements Stripe</h3>
        <p className="text-slate-500 text-sm mt-1">Les commandes sont encaissées via Stripe (mode test). La commission ci-contre est prélevée automatiquement sur chaque commande payée.</p>
        <span className="inline-flex items-center gap-2 mt-4 bg-green-100 text-green-700 rounded-full px-3 py-1.5 text-sm font-bold">● Connecté (test)</span>
      </div>
    </div>
  );
}
